export default __webpack_public_path__ + "static/media/borku-full-logo.e797b290.png";